<template>
  <v-container fluid v-if="visibleList.length > 0">
    <v-row class="mx-3 mt-2 mb-4 align-center">
      <v-col cols="12" md="8" class="pa-0">
        <h2 class="mps-title">Productos disponibles</h2>
        <p class="mps-subtitle mb-0">
          Productos y servicios que tu organización ha puesto a tu disposición.
        </p>
      </v-col>
    </v-row>

    <div class="mps-grid mx-3">
      <div
        v-for="ps in visibleList"
        :key="ps._id"
        class="mps-item"
        @click="goToCheckout(ps)"
      >
        <div class="mps-item__img-wrap">
          <img
            :src="ps.bannerImage || placeholderBanner"
            class="mps-item__img"
            :alt="ps.name"
          />
        </div>
        <div class="mps-item__body">
          <div class="mps-item__name">{{ ps.name }}</div>
          <div class="mps-item__short" v-if="ps.shortDescription">
            {{ ps.shortDescription }}
          </div>
          <div class="mps-item__price">{{ formatPrice(ps.price, ps.currency) }}</div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "MemberProductsServicesBlock",
  data() {
    return {
      placeholderBanner:
        "https://wechamber-public.s3.amazonaws.com/placeholders/product-service-placeholder.png",
    };
  },
  computed: {
    ...mapState("productServices", ["memberProductsServices"]),
    visibleList() {
      return (this.memberProductsServices || []).filter(
        (p) => p.status === "PUBLISHED"
      );
    },
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    ...mapActions("productServices", ["fetchMemberProductsServices"]),
    ...mapMutations("notification", ["show"]),
    async loadProducts() {
      const res = await this.fetchMemberProductsServices();
      if (!res.status) {
        this.show({ text: res.message || "Error al cargar productos.", color: "error" });
      }
    },
    formatPrice(value, currency) {
      const amount = Number(value || 0).toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return `$${amount} ${currency || "MXN"}`;
    },
    goToCheckout(ps) {
      if (!ps._id) return;
      this.$router
        .push({ name: "productServiceMicrositeById", params: { productServiceId: ps._id } })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.mps-title {
  color: #1b273e;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.5px;
}
.mps-subtitle {
  color: #5a6478;
  font-size: 14px;
}
/* Grid MercadoLibre */
.mps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0;
}
.mps-item {
  cursor: pointer;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  transition: background 0.15s;
}
.mps-item:hover {
  background: #f5f5f5;
}
.mps-item__img-wrap {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #f0f0f0;
}
.mps-item__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 12px;
}
.mps-item__body {
  padding: 10px 12px 14px;
}
.mps-item__name {
  color: #1b273e;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mps-item__short {
  color: #5a6478;
  font-size: 12px;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mps-item__price {
  color: #1b273e;
  font-weight: 700;
  font-size: 20px;
  margin-top: 8px;
  line-height: 1;
}
</style>
